<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BazAy/tc-custom/9781426862663.jpg?1725275240851" alt="This image is the cover for the book Merry Christmas, Babies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Merry Christmas, Babies
      </h1>
      <p class="bookDescription body article font2">
        <p>Business hotshot Elise Richardson is successful, beautiful, singleand her biological clock is clanging like a church bell. So independent Elise takes matters into her own hands and now she's pregnant—with quadruplets!<br/><br/>Her business partner and best friend, Joe Bennett, can't believe she's going to be a mom—times four! There's no way <i>he's</i> ready for the chaos of parenthood. Being one of seven children has taught him that much.<br/><br/>But now that Elise's doctor says she shouldn't be home alone, Joe's ready to move in. Strictly as a friend, of course. At least until Christmas</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Taylor Quinn
      </h2>
      
      <p class="authorDescription body article"> Tara Taylor Quinn, is a&#160;<I>USA Today</I>&ndash;bestselling author of one hundred novels, which have been translated into twenty languages and has sold more than seven million copies. Known for her intense emotional fiction, Quinn&rsquo;s novels have received critical acclaim, including the 2008 National Reader&rsquo;s Choice Award, and five RITA Award finalist, and a former president and board director of the Romance Writers of America. She has appeared often on local and national TV, including&#160;<I>CBS Sunday Morning</I>. For additional offers, news, and contests, visit the author at tarataylorquinn.com. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70e6b1e3